import { del, get, post } from '../../client';
import { shouldLogApiCalls } from '../../config';

export const listContacts = async (page_at, page_size, sort_by, sort_order, search_term, filters) => {
    if (shouldLogApiCalls) {
        console.log('List contacts attempt:', { page_at, page_size, sort_by, sort_order, search_term, filters });
    }
    
    return post('/contact', { page_at, page_size, sort_by, sort_order, search_term, filters });
}


export const getContact = async (contactId, page_at, page_size) => {
    if (shouldLogApiCalls) {
        console.log('Get contact attempt:', { contactId, page_at, page_size });
    }

    return get(`/contact?contact_external_id=${contactId}&page_at=${page_at}&page_size=${page_size}`);
}

export const identifyContact = async (externalId, data, clientKey) => {
    return post(`/contact/identify`, { external_id: externalId, data }, { headers: { "Client-Key": clientKey } });
}

export const bulkRemoveContactsFromTag = async (tagId, contactIds) => {
    return post(`/contact/tag/${tagId}`, { contacts: contactIds, is_deletion: true });
}

export const importContacts = async (data) => {
    return post(`/contact/bulk`, data);
}

export const deleteContact = async (contactId) => {
    return del(`/contact/${contactId}`);
}

export const exportContacts = async (filters) => {
    return post(`/contact/csv`, {filters}, {responseType: 'blob'});
}